import { EmoticonElement } from '../../slateTypes';

function emoticonSerializer(emoticonElement: EmoticonElement) {
  const { type, shortcut, packageName } = emoticonElement;
  return `{{#${type}.${packageName}}}${encodeURIComponent(shortcut)}{{/${type}.${packageName}}}`;
}

export default emoticonSerializer;
